import { RouteConfig } from '../../../../routing/types'

export type PathArgs = unknown[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'reset-password-reset',
  path: () => '/reset-password/:passwordToken',
  type: 'public',
}

export default ROUTE
